/** Должны быть идентичны бэкенду app/Models/Order.php */
export const CONTACT_MANAGER_DO_NOT_WANT_PAYMENT_REASON = 1;
export const CONTACT_MANAGER_DO_NOT_WANT_SEND_DOCUMENTS = 2;
